export const worldFr = {
  'world.seo.title': 'Le Monde',
  'world.seo.description':
    'Explorez les cartes interactives de Grymwyrd — ses royaumes, ses ruines et les scènes de légende, en cartographie 2D et globe rotatif 3D.',
  'world.heading': 'Le Monde',
  'world.intro':
    'Cartographiez le crépuscule éternel. L\'atlas est conçu pour une vision imbriquée — zoomez depuis le monde entier jusqu\'à un seul donjon. Seul le niveau supérieur est interactif pour le moment ; les niveaux plus profonds s\'ouvriront à mesure que les royaumes seront cartographiés.',

  'world.viewMode.label': 'Mode de vue cartographique',
  'world.viewMode.map2d': 'Carte 2D',
  'world.viewMode.globe3d': 'Globe 3D',

  'world.gazetteer.navLabel': 'Lieux et scènes',
  'world.gazetteer.heading': 'Gazetier',
  'world.gazetteer.sampleNotice':
    'Affichage d\'exemples de lieux — le véritable relevé du cartographe n\'a pas encore été enregistré.',
  'world.gazetteer.error': 'Les archives de l\'atlas n\'ont pas pu être atteintes.',

  'world.loading.atlas': 'Déroulement de l\'atlas…',
  'world.loading.globe': 'Rotation du monde…',

  'world.layersActive': '{active} sur {total} calques actifs.',
  'world.globeHint':
    'Glissez pour faire pivoter (la rotation automatique pause pendant votre exploration, reprend après une minute d\'inactivité) ; faites défiler pour zoomer. Survolez un hexagone pour révéler sa campagne, cliquez pour entrer.',
  'world.webglUnavailable':
    'Le globe 3D nécessite WebGL, qui est indisponible ici — affichage de l\'atlas 2D à la place.',

  'world.campaign.capitalRegion': 'Région Capitale',
  'world.campaign.territory': 'Territoire de Campagne',
  'world.campaign.enter': 'Entrer dans la Campagne',
  'world.campaign.stay': 'Rester en Orbite',

  'world.layers.heading': 'Couches Cartographiques',
  'world.layers.gmBadge': 'MJ',
  'world.layers.gmRequired': 'Nécessite un rôle de Maître de Jeu.',

  'world.marker.sampleBadge': 'Données d\'exemple',
  'world.marker.viewInEncyclopedia': 'Voir dans l\'Encyclopédie',
  'world.marker.placeholderNote':
    'Ceci est un site d\'espace réservé — une fois son histoire rédigée, il créera un lien vers l\'Encyclopédie.',

  'world.map2d.ariaLabel': 'Carte interactive du monde surplanaire',
  'world.map2d.noOverworld': 'Cartographie du monde surplanaire pas encore inscrite — affichage du vide',

  'world.globe.hint.enter': 'Entrer ▸',
  'world.globe.hint.open': 'Ouvrir ▸',
  'world.globe.hint.claim': 'Revendiquer ▸',
  'world.globe.uncharted': 'Contrées Non Cartographiées',
  'world.globe.unchartedBlurb':
    'Aucune campagne n\'a revendiqué cet hexagone du crépuscule éternel. Plantez la première bannière.',
  'world.globe.capitalLabel': 'Grymwyrd',
} as const
